export const RECENTS_TITLE = "activation.home.recents.title";
export const MORE_COMPETITORS = "activation.home.recents.more.competitors";
export const VIEW_PROJECT = "activation.home.project.view";
export const SETTINGS_TEXT = "activation.home.list.context.menu.settings.text";
export const CREATE_PROJECT = "project.creation.modal.header";
export const SUBSCRIBE_TOOLTIP = "activation.home.list.item.subscribe.tooltip";
export const SUBSCRIBED_TOOLTIP = "activation.home.list.item.unsubscribe.tooltip";
